import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Building2, Users, TrendingUp, ArrowRight } from 'lucide-react';
export function AboutSummary() {
  const highlights = [{
    icon: <Building2 size={28} strokeWidth={1.5} data-id="element-27" />,
    title: 'National Presence',
    desc: 'Operating across Nigeria with proven expertise'
  }, {
    icon: <Users size={28} strokeWidth={1.5} data-id="element-28" />,
    title: 'Expert Team',
    desc: 'Experienced engineers, architects, and project managers'
  }, {
    icon: <TrendingUp size={28} strokeWidth={1.5} data-id="element-29" />,
    title: 'Proven Track Record',
    desc: 'Successfully delivered projects worth over ₦500M'
  }];
  return <section className="py-16 sm:py-20 md:py-24 lg:py-32 bg-cream" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-32">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-33">
            <h2 className="font-heading font-semibold text-3xl sm:text-4xl md:text-5xl text-charcoal mb-6 sm:mb-8 leading-tight" data-id="element-34">
              We Build Structures.
              <br data-id="element-35" />
              We Build <span className="text-gold" data-id="element-36">Legacies</span>.
            </h2>
            <p className="text-stone text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed" data-id="element-37">
              Founded in 2021, FDF Gold Concept Nigeria Limited has rapidly
              established itself as a trusted partner in construction, civil
              engineering, and real estate development across Nigeria.
            </p>
            <p className="text-stone text-base sm:text-lg mb-8 sm:mb-10 leading-relaxed" data-id="element-38">
              With a national presence and multi-sector expertise, we deliver
              innovative solutions that combine technical excellence with
              sustainable practices.
            </p>
            <Link to="/about" data-id="element-39">
              <motion.button whileHover={{
              backgroundColor: '#D4B896'
            }} whileTap={{
              scale: 0.98
            }} className="group px-6 sm:px-8 py-3 sm:py-4 bg-gold text-charcoal font-semibold text-sm sm:text-[15px] transition-colors flex items-center gap-2" data-id="element-40">
                Learn More About Us
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" strokeWidth={2} data-id="element-41" />
              </motion.button>
            </Link>
          </motion.div>

          {/* Highlights */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-1 gap-6" data-id="element-42">
            {highlights.map((item, index) => <div key={index} className="bg-white border border-border p-6 sm:p-8 hover:border-stone/30 transition-colors" data-id="element-43">
                <div className="text-gold mb-4" data-id="element-44">{item.icon}</div>
                <h3 className="font-heading font-semibold text-lg sm:text-xl text-charcoal mb-2" data-id="element-45">
                  {item.title}
                </h3>
                <p className="text-stone text-sm sm:text-base" data-id="element-46">{item.desc}</p>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}